import { AkbSpecs, DisksSpecsAll, OilsSpecs, TruckTyresSpecs, TyresShortSpecsAll } from '../const/ShortSpecsByType';
import { ProductSpecs } from '../types/productSchema';

export const sortShortSpecProductTyres = (a: ProductSpecs, b: ProductSpecs) =>
  TyresShortSpecsAll.indexOf(a.code) - TyresShortSpecsAll.indexOf(b.code);

export const sortSpecProductTruckTyres = (a: ProductSpecs, b: ProductSpecs) =>
  TruckTyresSpecs.indexOf(a.code) - TruckTyresSpecs.indexOf(b.code);

export const sortShortSpecProductDisks = (a: ProductSpecs, b: ProductSpecs) => DisksSpecsAll.indexOf(a.code) - DisksSpecsAll.indexOf(b.code);

export const sortSpecProductAkb = (a: ProductSpecs, b: ProductSpecs) => AkbSpecs.indexOf(a.code) - AkbSpecs.indexOf(b.code);

export const sortSpecProductOils = (a: ProductSpecs, b: ProductSpecs) => OilsSpecs.indexOf(a.code) - OilsSpecs.indexOf(b.code);
